import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import csvIcon from './i/csv.svg'

import styles from './ExportButton.module.scss'

const ExportButton = ({ onClick, isDisabled = false }) => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    return (
        <div
            className={classNames(styles.export, { [styles.isDisabled]: isDisabled || isLoading })}
            onClick={async () => {
                try {
                    setIsLoading(true)
                    await onClick()
                } catch (err) {
                    console.error(err)
                } finally {
                    setIsLoading(false)
                }
            }}
        >
            {t('Export CSV')}
            <img src={csvIcon} alt="csv" />
        </div>
    )
}

export default ExportButton
